<template>
  <svg width="111" height="133" viewBox="0 0 60 72" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0)">
      <path
        d="M1.77304 62.8693V68.1459H0V54.6562H4.95354C6.42498 54.6562 7.57654 55.0325 8.40822 55.785C9.2399 56.5375 9.66031 57.5377 9.66031 58.7766C9.66031 60.0888 9.24904 61.0983 8.43564 61.8049C7.62223 62.5115 6.45239 62.8693 4.93526 62.8693H1.77304ZM1.77304 61.4103H4.95354C5.90403 61.4103 6.62604 61.19 7.12871 60.7404C7.63137 60.2907 7.88728 59.6392 7.88728 58.7949C7.88728 57.9874 7.63137 57.345 7.12871 56.8678C6.62604 56.3815 5.93145 56.1337 5.05407 56.1153H1.77304V61.4103Z"
        fill="#277FAF"
      />
      <path
        d="M16.4784 59.6574C16.2225 59.6116 15.9392 59.5932 15.6376 59.5932C14.5135 59.5932 13.7549 60.0704 13.3619 61.0248V68.1367H11.6528V58.1249H13.3162L13.3436 59.2812C13.9011 58.3819 14.6962 57.9414 15.7198 57.9414C16.0489 57.9414 16.3048 57.9873 16.4784 58.0699V59.6574Z"
        fill="#277FAF"
      />
      <path
        d="M17.4104 63.0435C17.4104 62.0616 17.6023 61.1807 17.9862 60.3915C18.37 59.6115 18.9093 59.0058 19.5947 58.5745C20.2802 58.1524 21.0662 57.9321 21.9435 57.9321C23.3053 57.9321 24.402 58.4001 25.2428 59.3453C26.0837 60.2905 26.5041 61.5477 26.5041 63.1169V63.2362C26.5041 64.209 26.3213 65.0899 25.9466 65.8608C25.5719 66.6316 25.0418 67.2373 24.3472 67.6686C23.6526 68.0999 22.8575 68.3201 21.9618 68.3201C20.6092 68.3201 19.5125 67.8521 18.6716 66.9069C17.8308 65.9617 17.4104 64.7137 17.4104 63.1536V63.0435V63.0435ZM19.1286 63.2454C19.1286 64.3558 19.3845 65.2459 19.8963 65.925C20.4081 66.5949 21.0936 66.9344 21.9618 66.9344C22.83 66.9344 23.5155 66.5949 24.0273 65.9066C24.5391 65.2276 24.795 64.264 24.795 63.0435C24.795 61.9423 24.5391 61.0522 24.0182 60.3731C23.4972 59.6941 22.8118 59.3453 21.9435 59.3453C21.1027 59.3453 20.4173 59.6849 19.9054 60.3548C19.3845 61.0338 19.1286 61.9974 19.1286 63.2454Z"
        fill="#277FAF"
      />
      <path
        d="M36.3289 64.6221H30.6991L29.4287 68.1459H27.6008L32.728 54.6562H34.2817L39.418 68.1459H37.5993L36.3289 64.6221ZM31.2292 63.163H35.7989L33.514 56.8495L31.2292 63.163Z"
        fill="#277FAF"
      />
      <path
        d="M49.3983 63.2455C49.3983 64.7688 49.051 65.9985 48.3564 66.9345C47.6618 67.8705 46.7205 68.3294 45.5324 68.3294C44.3168 68.3294 43.3663 67.944 42.6717 67.1731V72H40.9626V58.1249H42.5255L42.6077 59.2353C43.3023 58.3727 44.2711 57.9414 45.5049 57.9414C46.7022 57.9414 47.6527 58.3911 48.3473 59.2996C49.0419 60.208 49.3983 61.4744 49.3983 63.0895V63.2455ZM47.6892 63.0528C47.6892 61.9241 47.4516 61.0339 46.9672 60.3732C46.492 59.7217 45.8248 59.3913 44.9931 59.3913C43.9604 59.3913 43.1835 59.8501 42.6717 60.7678V65.558C43.1835 66.4757 43.9604 66.9253 45.0114 66.9253C45.8339 66.9253 46.4829 66.6042 46.9672 65.9434C47.4516 65.3011 47.6892 64.3375 47.6892 63.0528Z"
        fill="#277FAF"
      />
      <path
        d="M60.0001 63.2455C60.0001 64.7688 59.6528 65.9985 58.9582 66.9345C58.2636 67.8705 57.3223 68.3294 56.1341 68.3294C54.9186 68.3294 53.9681 67.944 53.2735 67.1731V72H51.5645V58.1249H53.1273L53.2095 59.2353C53.9041 58.3727 54.8729 57.9414 56.1067 57.9414C57.304 57.9414 58.2545 58.3911 58.9491 59.2996C59.6437 60.208 60.0001 61.4744 60.0001 63.0895V63.2455V63.2455ZM58.291 63.0528C58.291 61.9241 58.0534 61.0339 57.569 60.3732C57.0938 59.7217 56.4266 59.3913 55.5949 59.3913C54.5622 59.3913 53.7853 59.8501 53.2735 60.7678V65.558C53.7853 66.4757 54.5622 66.9253 55.6132 66.9253C56.4357 66.9253 57.0846 66.6042 57.569 65.9434C58.0534 65.3011 58.291 64.3375 58.291 63.0528Z"
        fill="#277FAF"
      />
      <path
        d="M12.4937 50.5267V23.2721C12.4937 19.2711 13.5081 15.3251 15.5371 11.8839C18.0687 7.61672 22.6018 3.25782 30.6444 2.86322C46.7206 2.0832 50.879 15.1049 51.3908 17.711C51.9026 20.3172 53.7213 29.1727 47.2415 36.7251C42.4982 42.2494 35.3238 43.2497 31.8143 43.3781C30.6719 43.424 29.7305 42.4972 29.7305 41.3593V31.8064C29.7305 30.7602 30.5256 29.8793 31.5675 29.7967C34.3276 29.5673 39.1897 28.3376 38.815 22.538C38.2941 14.4625 29.7396 16.0317 27.9209 17.8487C27.7655 18.0047 27.6284 18.1515 27.5005 18.2892C26.4312 19.473 25.8463 21.033 25.828 22.6297L25.6086 37.8538C25.5995 38.7164 25.4716 39.579 25.2248 40.4141C24.2286 43.7727 20.9933 51.6555 12.4937 50.5267Z"
        fill="#277FAF"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="12"
        y="2"
        width="41"
        height="49"
      >
        <path
          d="M12.521 50.5419V23.2872C12.521 19.2862 13.5355 15.3402 15.5644 11.899C18.096 7.63186 22.6292 3.27295 30.6718 2.87836C46.748 2.09834 50.9064 15.12 51.4182 17.7262C51.93 20.3323 53.7488 29.1878 47.2689 36.7402C42.5256 42.2645 35.3512 43.2648 31.8417 43.3933C30.6992 43.4392 29.7579 42.5123 29.7579 41.3744V31.8215C29.7579 30.7754 30.553 29.8944 31.5949 29.8118C34.355 29.5824 39.2171 28.3527 38.8424 22.5531C38.3215 14.4776 29.767 16.0469 27.9483 17.8638C27.7929 18.0198 27.6558 18.1667 27.5279 18.3043C26.4586 19.4881 25.8736 21.0481 25.8554 22.6449L25.636 37.8689C25.6269 38.7315 25.4989 39.5941 25.2522 40.4292C24.256 43.7879 21.0206 51.6706 12.521 50.5419Z"
          fill="#277FAF"
        />
      </mask>
      <g mask="url(#mask0)">
        <g filter="url(#filter0_d)">
          <path
            d="M43.7686 6.26759C40.6886 4.1019 36.4388 2.58775 30.6445 2.87223C22.6018 3.26682 18.0687 7.62573 15.5371 11.8929C13.499 15.3249 12.4937 19.2801 12.4937 23.2811V50.5358C20.9933 51.6645 24.2377 43.7817 25.2248 40.4231C25.4716 39.588 25.5904 38.7346 25.6087 37.8628L25.828 22.6387C25.8463 21.5467 26.1296 20.473 26.6414 19.5278C26.6414 19.5187 26.6414 19.5187 26.6414 19.5095C27.5553 9.82813 43.7686 6.26759 43.7686 6.26759Z"
            fill="url(#paint0_linear)"
          />
        </g>
        <path
          d="M35.5614 3.08369C34.0626 2.86345 32.4266 2.78086 30.6444 2.86345C22.6018 3.25804 18.0687 7.61695 15.5371 11.8841C13.499 15.3162 12.4937 19.2713 12.4937 23.2723V50.527C13.1243 50.6096 13.7183 50.6371 14.285 50.6279C20.7922 43.204 16.9537 34.89 17.6757 23.1806C18.4525 10.682 35.5614 3.08369 35.5614 3.08369Z"
          fill="url(#paint1_linear)"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d"
        x="8.49365"
        y="-1.16211"
        width="39.2749"
        height="55.8075"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.00293403 0 0 0 0 0.0345777 0 0 0 0 0.0541667 0 0 0 0.89 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>
      <linearGradient
        id="paint0_linear"
        x1="12.4895"
        y1="26.7332"
        x2="43.7666"
        y2="26.7332"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#277FAF" />
        <stop offset="0.3356" stop-color="#2578AD" />
        <stop offset="0.8385" stop-color="#1E63A6" />
        <stop offset="1" stop-color="#1C5BA3" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="12.4895"
        y1="26.7311"
        x2="35.5578"
        y2="26.7311"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="8.24799e-08" stop-color="#1C5BA3" />
        <stop offset="0.1615" stop-color="#1E63A6" />
        <stop offset="0.6644" stop-color="#2578AD" />
        <stop offset="1" stop-color="#277FAF" />
      </linearGradient>
      <clipPath id="clip0">
        <rect width="60" height="72" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'ContactsFooter',
}
</script>

<style scoped></style>
